export default "__VITE_ASSET__b17e54e1__"